<template>
	<div class="mainSearch">
		<!-- <ais-autocomplete/> -->
		<ais-search-box>
			<div class="searchContainer" slot-scope="{ refine }">
				<ais-clear-refinements>
				<span @click="$refs.searchBox.value=''" slot="resetLabel" class="clearFilters">Clear Filters</span>
				<!--	<ClearFiltersIcon slot="resetLabel" class="icon" />-->
				</ais-clear-refinements>
				<div class="searchBarContainer">
					<InputField
						label="Search Website"
						type="search"
						@input="doSearch($event, refine)"
						v-on:keydown.enter="enterPressed"
						v-model="search"
						ref="searchBox"
					/>
				</div>
				<div class="searchButtonContainer">
					<button @click="doSearch($refs.searchBox.value, refine)" ref="doSearch">
						<SearchIcon class="icon"/>
						<span class="d-none">Submit Search</span>
					</button>
				</div>
			<!-- <span :hidden="!isSearchStalled">Loading...</span> -->
			</div>

		</ais-search-box>
	</div>
</template>

<script>
import SearchIcon from "@/assets/img/search.svg"
import ClearFiltersIcon from "@/assets/img/clearFilter.svg";
import InputField from "@/components/forms/InputField";

import {  AisSearchBox, AisClearRefinements } from 'vue-instantsearch';

export default {
	//TODO remove the Faceting errors that occasionally occur with Algolia. Not sure yet.
	name: "SearchBar",
	components: {
		AisSearchBox,
		AisClearRefinements,
		InputField,
		// AisAutocomplete,
		// AisHits,
		SearchIcon,
		ClearFiltersIcon
	},
	data() {
		return {
			search:this.$route.query.s || sessionStorage.getItem("search"),//set value to current query on page load
		};
	},
	methods: {
		doSearch(value, searchFunction) {
			if(!value) {
				sessionStorage.setItem("search", value)
				return;
			} 
			//call the algolia search function first
			searchFunction(value)

			//redirect to search results page if not already on it
			if(this.$route.name != "search" && value != ""){
				this.$router.push({ name: "search" ,query:{s:value}}).catch(err=>{});
			} else {
				this.$router.replace({query:{s:value}}).catch(err=>{})
			}
			sessionStorage.setItem("search", value)
		},
		enterPressed(){
			document.activeElement.blur();  //close keyboard on mobile devices
		},
	},
	watch: {
		//Perform a search when the link is pasted in
		$route(to) {
			this.$nextTick(()=>{
				if (to.query.s && to.name=="search"){
				this.search = to.query.s;
				this.$refs.doSearch.click()
				this.$router.replace({query:{s:this.search}}).catch(err=>{})
				}
			})
		}
	}
};
</script>

<style lang="scss" scoped>
	.mainSearch::v-deep {
		padding-top: 10px;
		padding-bottom: 10px;
		.searchBarContainer {
			width: calc(100% - #{$searchButtonWidth} - 40px - #{$searchButtonWidth});
			box-sizing: border-box;
			height: 30px;
			display: inline-flex;

			.formInputGroup {
				margin: 0;
				.inputField {
					border-radius: 0;
					height: 100%;
					&:focus ~ label,
					&.hasValue ~ label {
						top: -12px;
						font-size: 0.8rem;
					}
				}
				label {
					top: 4px;
					left: 5px;
				}

				.inputField, label {
					font-size: 1rem;
				}
			}
		}
		.searchContainer{
			position:relative;
			display: flex;
			flex: auto;
		}

		.searchButtonContainer{
			width: $searchButtonWidth;
			display: inline-flex;
			position: relative;
			height: 100%;
			button {
				border-radius: 0 5px 5px 0;
				background-color: black;
				border: 0;
			}
		}

		.icon{
			color: white;
			fill: white;
			height: 100%;
			width: 100%;
			padding: 2px;
		}
		

	}
</style>
